import React from 'react';
import PropTypes from 'prop-types';
import { Button, Range } from 'day8-ui';
import { FaBarsProgress } from "@react-icons/all-files/fa6/FaBarsProgress";
import { CAPACITY, FILTERS } from '../../../../constants';
import { getSelectedFilters, onFilterSelect } from '../../../../helpers/filter';
import history from '../../../../history';
import { useDispatch } from 'react-redux';

const Capacity = props => {
  const dispatch = useDispatch();
  const selectedFilters = getSelectedFilters(props.location);
  const minCapacity = selectedFilters.minCapacity || CAPACITY.MIN;
  const maxCapacity = selectedFilters.maxCapacity || CAPACITY.MAX;
  const updateCapacity = values => {
    const newMinCapacity = values[0];
    const newMaxCapacity = values[1];
    if (newMinCapacity !== minCapacity) {
      onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.MIN_CAPACITY, newMinCapacity);
    }
    if (newMaxCapacity !== maxCapacity) {
      onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.MAX_CAPACITY, newMaxCapacity);
    }
  };
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Capacity</h3>
      <div className="dui-mt-4">
        <Range min={CAPACITY.MIN} max={CAPACITY.MAX} valueMin={minCapacity} valueMax={maxCapacity} onRangeChange={updateCapacity} isDualThumb valueLabel="guests" />
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<FaBarsProgress />}>{minCapacity} - {maxCapacity} guests</Button>;
};
Capacity.propTypes = {
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired
};
export default Capacity;
